module.exports = __webpack_public_path__ + "img/fail.0131dd26.png";